import {FormProvider} from "react-hook-form";

import {Button} from "@pg-design/button-module";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "@/features/home_match/constants/preferences/home_match_preferences_wizard_content";

import {usePhoneNumberPatchForm} from "../../hooks/use_phone_number_patch_form";
import {UserFlowModal} from "./UserFlowModal";
import {UserPhoneNumberInput} from "./UserPhoneNumberInput";

const {PHONE_DESCRIPTION, PHONE_SUBMIT, PHONE_TITLE} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

export const USER_PHONE_NUMBER_MODAL_PROGRESS = 50;

interface IProps {
    isOpen: boolean;
    onCloseButton: () => void;
    onSuccess?: (phone: string) => void;
    progress: number;
}

export const UserPhoneNumberModal = (props: IProps) => {
    const {isOpen, onCloseButton, onSuccess, progress} = props;
    const {form, isSubmitting, onSubmit} = usePhoneNumberPatchForm({
        onPhoneNumberSaved: (savedPhone) => {
            if (onSuccess) {
                onSuccess(savedPhone);
                return;
            }

            onCloseButton();
        }
    });

    return (
        <FormProvider {...form}>
            <UserFlowModal
                description={PHONE_DESCRIPTION}
                footer={
                    <Button
                        disabled={isSubmitting}
                        fullWidth
                        isLoading={isSubmitting}
                        size="small"
                        textVariant="button_medium"
                        type="submit"
                        variant="filled_secondary"
                    >
                        {PHONE_SUBMIT}
                    </Button>
                }
                isOpen={isOpen}
                onClose={onCloseButton}
                onSubmit={onSubmit}
                progress={progress}
                title={PHONE_TITLE}
            >
                <UserPhoneNumberInput />
            </UserFlowModal>
        </FormProvider>
    );
};
import {FormProvider} from "react-hook-form";

import {Button} from "@pg-design/button-module";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "@/features/home_match/constants/preferences/home_match_preferences_wizard_content";

import {usePhoneNumberPatchForm} from "../../hooks/use_phone_number_patch_form";
import {UserFlowModal} from "./UserFlowModal";
import {UserPhoneNumberInput} from "./UserPhoneNumberInput";

const {PHONE_DESCRIPTION, PHONE_SUBMIT, PHONE_TITLE} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

export const USER_PHONE_NUMBER_MODAL_PROGRESS = 50;

interface IProps {
    isOpen: boolean;
    onCloseButton: () => void;
    onSuccess?: (phone: string) => void;
    progress: number;
}

export const UserPhoneNumberModal = (props: IProps) => {
    const {isOpen, onCloseButton, onSuccess, progress} = props;
    const {form, isSubmitting, onSubmit} = usePhoneNumberPatchForm({
        onPhoneNumberSaved: (savedPhone) => {
            if (onSuccess) {
                onSuccess(savedPhone);
                return;
            }

            onCloseButton();
        }
    });

    return (
        <FormProvider {...form}>
            <UserFlowModal
                description={PHONE_DESCRIPTION}
                footer={
                    <Button
                        disabled={isSubmitting}
                        fullWidth
                        isLoading={isSubmitting}
                        size="small"
                        textVariant="button_medium"
                        type="submit"
                        variant="filled_secondary"
                    >
                        {PHONE_SUBMIT}
                    </Button>
                }
                isOpen={isOpen}
                onClose={onCloseButton}
                onSubmit={onSubmit}
                progress={progress}
                title={PHONE_TITLE}
            >
                <UserPhoneNumberInput />
            </UserFlowModal>
        </FormProvider>
    );
};
